export default __webpack_public_path__ + "static/the-gables-homepage-loop-video-poster-cc0da71394382c4ba66a89d33242d1a4.jpg";